/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const NoOptionsMessage = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.NoOptionsMessage {...otherProps} className={className}>
      {children}
    </components.NoOptionsMessage>
  );
};

NoOptionsMessage.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

NoOptionsMessage.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default NoOptionsMessage;
